import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { auth, db } from "../../../../firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import dayjs from "dayjs";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { FaDollarSign, FaPercent } from "react-icons/fa";

import PageHeading from "../../../../components/common/PageHeading";
import MultiSelect from "../../../../components/common/MultiSelect";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import EditEelectronicSignature from "../../../../components/common/EditElectronicSignature";
import { v4 as uuidv4 } from "uuid";

const termsOptions = [];
let i = 3;
while (i <= 24) {
  termsOptions.push({ value: `${i} month` });
  i = i + 3;
}

const PrepareRenewalOffer = () => {
  const [template, setTemplate] = useState(1);
  const [renewalOptions, setRenewalOptions] = useState(true);
  const [monthToMonth, setMonthToMonth] = useState(true);
  const [addendaTemplates, setAddendaTemplates] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [mtmAddendaTemplates, setMtmAddendaTemplates] = useState([]);
  const [mtmAtachments, setMtmAttachments] = useState([]);

  const randomId = uuidv4();

  const [terms, setTerms] = useState([
    {
      id: randomId,
      term: "",
      endDate: "",
      changeByDollar: "",
      changeByPercent: "",
      newRent: "",
    },
  ]);
  const [monthlyCharges, setMonthlyCharges] = useState([
    {
      id: 1,
      description: "",
      glAccount: "",
      currentAmount: "",
      changeByDollar: "",
      changeByPercent: "",
      newAmount: "",
    },
  ]);
  const [isrenewalDefault, setIsRenewalDefault] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lease, setLease] = useState({});
  const [tenantName, setTenantName] = useState("");
  const [property, setProperty] = useState({});
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (companyName) {
      const fetchLeases = async () => {
        const leaseRef = collection(db, "companies", companyName, "leases");
        const propertiesRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const tenantRef = collection(db, "companies", companyName, "tenants");

        const properties = await getDocs(propertiesRef);
        const propertiesFetched = properties.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const tenants = await getDocs(tenantRef);
        const tenantsFetched = tenants.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        try {
          const snapShot = await getDocs(leaseRef);
          const fetchedData = snapShot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log("fetched leases", fetchedData);
          const leaseData = fetchedData.find((item) => item.id === id);
          const tenantData = tenantsFetched.find(
            (item) => item.id === leaseData.tenantId
          );
          const propertyData = propertiesFetched.find(
            (item) => item.id === leaseData.propertyId
          );
          setTenantName(
            tenantData.profileInfo.firstName +
              " " +
              tenantData.profileInfo.lastName
          );
          setProperty(propertyData);
          setLease(leaseData);
          console.log("fetched lease data", leaseData);
        } catch (err) {
          console.log("Error while fetching data", err);
        }
      };
      fetchLeases();
    }
    console.log("useEffect in prepare renewals page");
  }, [companyName]);

  const handleInputChange = (value, name, id) => {
    const updatedTerms = terms.map((term) => {
      if (term.id === id) {
        return { ...term, [name]: value };
      }
      return term;
    });
    setTerms(updatedTerms);
  };

  const addTerm = () => {
    const newTerm = {
      id: randomId,
      term: "",
      endDate: "",
      changeByDollar: "",
      changeByPercent: "",
      newRent: "",
    };
    setTerms([...terms, newTerm]);
  };

  const removeTerm = (id) => {
    const updatedTerms = terms.filter((term) => term.id !== id);
    setTerms(updatedTerms);
  };

  //Monhtly charges start

  const handleChange = (value, name, id) => {
    const updatedMonthlyCharge = monthlyCharges.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setMonthlyCharges(updatedMonthlyCharge);
  };

  const addMonthlyCharge = () => {
    const newCharge = {
      id: monthlyCharges.length + 1,
      description: "",
      glAccount: "",
      currentAmount: "",
      changeByDollar: "",
      changeByPercent: "",
      newAmount: "",
    };
    setMonthlyCharges([...monthlyCharges, newCharge]);
  };

  const removeMonthlyCharge = (id) => {
    const updatedMonthlyCharge = monthlyCharges.filter(
      (term) => term.id !== id
    );
    setMonthlyCharges(updatedMonthlyCharge);
  };

  //Monhtly charges end

  const handleTemplate = (e) => {
    console.log("radio checked", e.target.value);
    setTemplate(e.target.value);
  };
  const navigate = useNavigate();

  const backToRenewals = () => {
    navigate("/leasing/renewals");
  };

  const handleFormSubmit = async (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const filteredTerms = terms.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const filteredMonthlyCharges = monthlyCharges.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const renewalPackage = [
      {
        renewalPackageMethod:
          values.renewalPackageMethod === 1
            ? "Use AppFolio Lease"
            : "Use PDF Form Templates",
        documentsToInclude: {
          includeRenewalNoticeLetter: values.includeRenewalNoticeLetter,
          sendEmailReminders: values.sendEmailReminders,
          insuranceRequirement: values.insuranceRequirement,
          includeRenewalOptions: values.includeRenewalOptions,
          monthToMonthRenewal: values.monthToMonthRenewal,
          leaseStartDate: values.leaseStartDate.format("YYYY-MM-DD"),
          proratedCharges: values.proratedCharges,
          deadlineToRespond: values.deadlineToRespond.format("YYYY-MM-DD"),
          includeGiveNoticeOption: values.includeGiveNoticeOption,
        },
        renewalOption: {
          leaseTemplate: values.leaseTemplate,
          addendaTemplates: addendaTemplates,
          attachments: attachments,
          garageRemotes: values.garageRemotes,
          terms: filteredTerms.length > 0 ? filteredTerms : [],
        },
        monthToMonthOption: {
          leaseTemplate: values.mtmLeaseTemplate,
          addendaTemplates: mtmAddendaTemplates,
          attachments: mtmAtachments,
          MTMRent: {
            changeByDollar: values.changeByDollar,
            changeByPercent: values.changeByPercent,
            newRent: values.newRent,
          },
          additionalFee: values.additionalFee,
          garageRemotes: values.mtmGarageRemotes,
        },
        monthlyCharges: {
          monthlyCharges: filteredMonthlyCharges,
          chargeMonthType: values.chargeMonthType,
          showExpiredCharges: values.showExpiredCharges,
        },
        additionalSettings: {
          renewByDefault: values.renewByDefault,
          defaultOption: values.defaultOption,
        },
      },
    ];
    const renewalOffers = {
      renewalOffers: renewalPackage.concat(
        lease?.renewalOffers?.length > 0 ? lease?.renewalOffers : []
      ),
    };
    const leaseRef = doc(db, "companies", companyName, "leases", id);
    try {
      await updateDoc(leaseRef, renewalOffers);
      toast.success("Updated");
    } catch (err) {
      toast.error("Error while updating");
      console.log(err);
    }
    console.log("terms", terms);
  };

  const onFinishFailed = (err) => {
    console.log(err);
  };

  const initialValues = {
    includeRenewalNoticeLetter: true,
    sendEmailReminders: true,
    insuranceRequirement: true,
    includeRenewalOptions: true,
    monthToMonthRenewal: true,
    leaseStartDate: dayjs(),
    proratedCharges: true,
    deadlineToRespond: dayjs(),
    includeGiveNoticeOption: true,
    renewByDefault: true,
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const onCancelModal = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "GL Account",
      dataIndex: "GLAccount",
      width: "90%",
      render: (_, record) => <span>{record.glAccount}</span>,
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      render: (_, record) => <span>{record.amount}</span>,
    },
  ];

  const preparRenewalsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "Lease Templates",
        "1",
        "",
        "",
        "/leasing/leases/lease-templates"
      ),
      RightBarMethod(
        "PDF Form Templates",
        "2",
        "",
        "",
        "/leasing/leases/pdf-form-templates"
      ),
      RightBarMethod(
        <span onClick={showModal}>Edit Electronic Signature</span>,
        "3",
        "",
        "",
        ""
      ),
    ]),

    RightBarMethod(
      " HELP TOPICS",
      "t3",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("Send Lease Renewal Offers", "4", "", "", "/"),
        RightBarMethod("Send Renewal Letters", "5", "", "", "/"),
      ]
    ),
  ];

  const { id } = useParams();

  let totalMonthliCharges = 0;

  for (let i = 0; i < lease?.monthlyCharges?.length; i++) {
    totalMonthliCharges =
      totalMonthliCharges + parseInt(lease?.monthlyCharges[i].amount);
  }

  const filteredMonthlyCharges = monthlyCharges.filter((item) => {
    return Object.keys(item).some(
      (key) => key !== "id" && item["glAccount"] !== ""
    );
  });

  let newMonthlyCharges = 0;

  for (let i = 0; i < filteredMonthlyCharges.length; i++) {
    newMonthlyCharges =
      newMonthlyCharges + parseInt(filteredMonthlyCharges[i].newAmount);
  }

  return (
    <div className="page-container">
      <div className="main-container">
        <p onClick={backToRenewals} className="onclick-text">
          <i
            className="fa-solid fa-circle-arrow-left"
            style={{ marginRight: "5px" }}
          ></i>
          Back to Renewals Page
        </p>
        <PageHeading heading="Renewal Offer" />
        <Form
          name="basic"
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 16,
          }}
          colon={false}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
          initialValues={initialValues}
        >
          <Card title="Current Lease Summary">
            <Form.Item label="Name">
              <a href="#">{tenantName}</a>
            </Form.Item>
            <Form.Item label="Property - Unit">
              <a href="#">
                {property?.propertyNameAddress?.propertyName +
                  " - " +
                  property?.propertyNameAddress?.propertyAddressOne}
              </a>
            </Form.Item>
            <Form.Item label="Unit Type">
              {property?.propertyNameAddress?.propertyType}
            </Form.Item>
            <Form.Item label="Move In Date">
              <span>{lease?.leaseDates?.moveInDate}</span>
            </Form.Item>
            <Form.Item label="Current Lease Dates">
              <span>
                {lease?.leaseDates?.monthToMonth
                  ? "--"
                  : lease?.leaseDates?.leaseStartDate +
                    " - " +
                    lease?.leaseDates?.leaseEndDate}
              </span>
            </Form.Item>
            <Form.Item label="Market Rent"></Form.Item>

            <h4>Monthly Charges</h4>
            <Table
              columns={columns}
              dataSource={lease?.monthlyCharges}
              pagination={false}
            />
            <p style={{ textAlign: "right", padding: "10px" }}>
              Total: <b>${totalMonthliCharges}</b>
            </p>
          </Card>
          <br />
          <Card title="Renewal Package">
            <Form.Item>
              <Radio.Group
                onChange={handleTemplate}
                value={template}
                name="renewalPackageMethod"
              >
                <Space direction="vertical">
                  <Radio value={1}>Use AppFolio Lease</Radio>
                  <Radio value={2}>Use PDF Form Templates</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Divider />
            <p>
              {template === 1
                ? "Choose which document(s) you would like to include in your Renewal Package"
                : "Specify the details and terms of your Renewal Package"}
            </p>
            <Form.Item
              label="Include Letter"
              name="includeRenewalNoticeLetter"
              valuePropName="checked"
            >
              <Checkbox disabled={template === 1 ? false : true}>
                Renewal Notice Letter
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="Include Email"
              name="sendEmailReminders"
              valuePropName="checked"
            >
              <Checkbox>
                Send reminder email about Renters Insurance{" "}
                <a href="#">Preview Email</a>
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="Insurance Requirement"
              name="insuranceRequirement"
              valuePropName="checked"
            >
              <Checkbox>
                This lease requires the tenant to demonstrate proof of liability
                insurance for at least $100,000.
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="Include Option(s)"
              required
              name="includeRenewalOptions"
              valuePropName="checked"
            >
              <Checkbox onChange={() => setRenewalOptions(!renewalOptions)}>
                Renewal Lease/Addenda
              </Checkbox>
            </Form.Item>
            <Form.Item
              label=" "
              name="monthToMonthRenewal"
              valuePropName="checked"
            >
              <Checkbox onChange={() => setMonthToMonth(!monthToMonth)}>
                Month To Month
              </Checkbox>
            </Form.Item>
            <Form.Item label="Start Date" name="leaseStartDate">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="Prorate Charges"
              name="proratedCharges"
              valuePropName="checked"
            >
              <Checkbox></Checkbox>
            </Form.Item>
            <Form.Item label="Deadline to Respond" name="deadlineToRespond">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="Include Give Notice Option"
              name="includeGiveNoticeOption"
              valuePropName="checked"
            >
              <Checkbox>
                Display give notice option in Renewal Notice block in online
                portal
              </Checkbox>
            </Form.Item>

            {renewalOptions && (
              <>
                <Divider />
                <h4>Add Renewal Option</h4>
                {template === 1 && (
                  <>
                    <Form.Item label="Include Lease" name="leaseTemplate">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Lease Template"
                        options={[
                          {
                            value: "New Move in Lease Template",
                            label: "New Move in Lease Template",
                          },
                          {
                            value: "New Move in Lease Template Copy (TEST)",
                            label: "New Move in Lease Template Copy (TEST)",
                          },
                          {
                            value: "Renewal Lease Template",
                            label: "Renewal Lease Template",
                          },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item label="Include Addenda" name="addendaTemplates">
                      <MultiSelect
                        options={["test1", "test2", "test3"]}
                        placeholder="Select Addenda Template"
                        callBackItems={setAddendaTemplates}
                      />
                    </Form.Item>
                    <Form.Item label="Include Attachments" name="attachments">
                      <MultiSelect
                        options={["test.pdf", "test2.pdf"]}
                        placeholder="Select Attachments"
                        callBackItems={setAttachments}
                      />
                    </Form.Item>
                    <Divider />
                    <p>Enter values for manual fields:</p>
                    <Form.Item label="Garage Remotes" name="garageRemotes">
                      <Input />
                    </Form.Item>
                  </>
                )}
                <Form.Item label="Renewal Option(s)" required>
                  <ul>
                    <Row style={{ marginBottom: 12 }} gutter={16}>
                      <Col className="tableHead" span={5}>
                        <p>Term</p>
                      </Col>
                      <Col className="tableHead" span={5}>
                        <p>End Date</p>
                      </Col>
                      <Col className="tableHead" span={5}>
                        <p>Change by $</p>
                      </Col>
                      <Col className="tableHead" span={4}>
                        <p>Change by %</p>
                      </Col>
                      <Col className="tableHead" span={4}>
                        <p>New Rent</p>
                      </Col>
                      <Col span={1}></Col>
                    </Row>
                    {terms.map((item, index) => (
                      <li key={index}>
                        <Row gutter={16}>
                          <Col span={5}>
                            <Select
                              placeholder="Select Term"
                              style={{ width: "100%" }}
                              options={termsOptions}
                              value={item.term}
                              onChange={(value) =>
                                handleInputChange(value, "term", item.id)
                              }
                            />
                          </Col>
                          <Col span={5}>
                            <DatePicker
                              style={{ width: "100%" }}
                              value={item.endDate}
                              onChange={(value) =>
                                handleInputChange(value, "endDate", item.id)
                              }
                            />
                          </Col>
                          <Col span={5}>
                            <InputNumber
                              addonBefore={<FaDollarSign size={12} />}
                              style={{ textAlign: "right" }}
                              value={item.changeByDollar}
                              onChange={(value) =>
                                handleInputChange(
                                  value,
                                  "changeByDollar",
                                  item.id
                                )
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <InputNumber
                              addonAfter={<FaPercent size={12} />}
                              value={item.changeByPercent}
                              onChange={(value) =>
                                handleInputChange(
                                  value,
                                  "changeByPercent",
                                  item.id
                                )
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <InputNumber
                              addonBefore={<FaDollarSign size={12} />}
                              style={{ textAlign: "right" }}
                              value={item.newRent}
                              onChange={(value) =>
                                handleInputChange(value, "newRent", item.id)
                              }
                            />
                          </Col>
                          <Col span={1}>
                            {terms.length > 1 ? (
                              <Button
                                className="roundSmallButton"
                                onClick={() => {
                                  removeTerm(item.id);
                                }}
                                type="primary"
                                shape="circle"
                                icon={
                                  <i className="fa-sharp fa-solid fa-xmark"></i>
                                }
                                size={"small"}
                              />
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                        <br />
                      </li>
                    ))}
                    <Form.Item label="">
                      <Button
                        className="addPropertyGroupButton"
                        type="primary"
                        onClick={addTerm}
                        style={{ width: "100%" }}
                        icon={<i className="fa-solid fa-circle-plus"></i>}
                      >
                        Add Another Renewal Option
                      </Button>
                    </Form.Item>
                  </ul>
                </Form.Item>
              </>
            )}
            {monthToMonth && (
              <>
                <Divider />
                <h4>Add Month To Month Option</h4>
                {template === 1 && (
                  <>
                    <p style={{ marginBottom: "10px" }}>
                      Choose the appropriate lease and/or addenda templates
                      below
                    </p>
                    <Form.Item label="Include Lease" name="mtmLeaseTemplate">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Lease Template"
                        options={[
                          {
                            value: "New Move in Lease Template",
                            label: "New Move in Lease Template",
                          },
                          {
                            value: "New Move in Lease Template Copy (TEST)",
                            label: "New Move in Lease Template Copy (TEST)",
                          },
                          {
                            value: "Renewal Lease Template",
                            label: "Renewal Lease Template",
                          },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item label="Include Addenda">
                      <MultiSelect
                        options={["test1", "test2", "test3"]}
                        placeholder="Select Addenda Template"
                        callBackItems={setMtmAddendaTemplates}
                      />
                    </Form.Item>
                    <Form.Item label="Include Attachments">
                      <MultiSelect
                        options={["test.pdf", "test2.pdf"]}
                        placeholder="Select Attachments"
                        callBackItems={setMtmAttachments}
                      />
                    </Form.Item>
                  </>
                )}
                <Form.Item label="MTM Rent" required>
                  <ul>
                    <Row style={{ marginBottom: 12 }} gutter={16}>
                      <Col className="tableHead" span={8}>
                        <p>Change by $</p>
                      </Col>
                      <Col className="tableHead" span={8}>
                        <p>Change by %</p>
                      </Col>
                      <Col className="tableHead" span={8}>
                        <p>New Rent</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item name="changeByDollar">
                          <Input
                            addonBefore={<FaDollarSign size={12} />}
                            defaultValue={(Math.round(0 * 100) / 100).toFixed(
                              2
                            )}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item name="changeByPercent">
                          <Input suffix={<FaPercent size={12} />} />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item name="newRent">
                          <Input
                            addonBefore={<FaDollarSign size={12} />}
                            defaultValue={(Math.round(0 * 100) / 100).toFixed(
                              2
                            )}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </ul>
                </Form.Item>
                <Form.Item label="Additional Fee" name="additionalFee">
                  <Input
                    addonBefore={<FaDollarSign size={12} />}
                    defaultValue={(Math.round(0 * 100) / 100).toFixed(2)}
                  />
                </Form.Item>
                <Divider />
                <p>Enter values for manual fields:</p>
                <Form.Item label="Garage Remotes" name="mtmGarageRemotes">
                  <Input />
                </Form.Item>
              </>
            )}
          </Card>
          <br />
          <Card title="Monthly Charges">
            <ul>
              <Row style={{ marginBottom: 12 }} gutter={16}>
                <Col className="tableHead" span={4}>
                  <p>Description</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>GL Account</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>Current Amount</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>Change by $</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>Change by %</p>
                </Col>
                <Col className="tableHead" span={4}>
                  <p>New Amount</p>
                </Col>
              </Row>
              {monthlyCharges.map((item, index) => (
                <li key={index}>
                  <Row gutter={16}>
                    <Col span={4}>
                      <Input
                        value={item.description}
                        onChange={(e) =>
                          handleChange(e.target.value, "description", item.id)
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <Select
                        placeholder="Select Term"
                        style={{ width: "100%" }}
                        options={[
                          { value: "test 1" },
                          { value: "test 2" },
                          { value: "test 3" },
                        ]}
                        value={item.glAccount}
                        onChange={(value) =>
                          handleChange(value, "glAccount", item.id)
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        addonBefore={<FaDollarSign size={12} />}
                        style={{ textAlign: "right" }}
                        disabled
                        value={item.currentAmount}
                        onChange={(value) =>
                          handleChange(value, "currentAmount", item.id)
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        addonBefore={<FaDollarSign size={12} />}
                        style={{ textAlign: "right" }}
                        disabled
                        value={item.changeByDollar}
                        onChange={(value) =>
                          handleChange(value, "changeByDollar", item.id)
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <InputNumber
                        addonAfter={<FaPercent size={12} />}
                        disabled
                        value={item.changeByPercent}
                        onChange={(value) =>
                          handleChange(value, "changeByPercent", item.id)
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <Row gutter={16}>
                        <Col span={20}>
                          <InputNumber
                            addonBefore={<FaDollarSign size={12} />}
                            value={item.newAmount}
                            onChange={(value) =>
                              handleChange(value, "newAmount", item.id)
                            }
                            style={{ textAlign: "right" }}
                          />
                        </Col>
                        <Col span={4}>
                          <Button
                            className="roundSmallButton"
                            onClick={() => {
                              removeMonthlyCharge(item.id);
                            }}
                            type="primary"
                            shape="circle"
                            icon={
                              <i className="fa-sharp fa-solid fa-xmark"></i>
                            }
                            size={"small"}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <br />
                </li>
              ))}
              <Button
                className="addPropertyGroupButton"
                type="primary"
                onClick={addMonthlyCharge}
                style={{ width: "100%" }}
                icon={<i className="fa-solid fa-circle-plus"></i>}
              >
                Add Another Monthly Charge
              </Button>
            </ul>

            <Divider />
            <h4>Review New Monthly Charges</h4>
            <Form.Item name="chargeMonthType">
              <Select
                options={[
                  { value: "12 month", label: "12 month" },
                  { value: "Month to month", label: "Month to month" },
                ]}
                style={{ width: "15%" }}
              />
            </Form.Item>
            <br />
            <Form.Item name="showExpiredCharges" valuePropName="checked">
              <Checkbox>Show Expired Charges</Checkbox>
            </Form.Item>

            <Row style={{ marginBottom: 12 }} gutter={16}>
              <Col className="tableHead" span={5}>
                <p>Start Date</p>
              </Col>
              <Col className="tableHead" span={5}>
                <p>End Date</p>
              </Col>
              <Col className="tableHead" span={5}>
                <p>Description</p>
              </Col>
              <Col className="tableHead" span={5}>
                <p>GL Account</p>
              </Col>
              <Col className="tableHead" span={4}>
                <p>Amount</p>
              </Col>
            </Row>
            {filteredMonthlyCharges.map((item, index) => {
              return (
                <Row style={{ marginBottom: 12 }} gutter={16} key={index}>
                  <Col span={5}>
                    <p>01/01/2024</p>
                  </Col>
                  <Col span={5}>
                    <p>--</p>
                  </Col>
                  <Col span={5}>
                    <p>{item.description}</p>
                  </Col>
                  <Col span={5}>
                    <p>{item.glAccount}</p>
                  </Col>
                  <Col span={4}>
                    <p>$ {item.newAmount}</p>
                  </Col>
                </Row>
              );
            })}
            <p style={{ textAlign: "right", padding: "10px" }}>
              Total: <b>$ {newMonthlyCharges}</b>
            </p>
          </Card>
          {template === 1 && (
            <>
              <br />
              <Card title="Additional Settings">
                <Form.Item
                  label="Renew by Default"
                  name="renewByDefault"
                  valuePropName="checked"
                >
                  <Checkbox
                    onChange={() => setIsRenewalDefault(!isrenewalDefault)}
                  ></Checkbox>
                </Form.Item>
                {isrenewalDefault && (
                  <Form.Item
                    label="Default Option"
                    required
                    name="defaultOption"
                    rules={[{ required: true, message: "Can't be blank" }]}
                  >
                    <Select
                      placeholder="Select Option"
                      style={{ width: "100%" }}
                      options={[
                        { value: "option 1" },
                        { value: "option 2" },
                        { value: "option 3" },
                      ]}
                    />
                  </Form.Item>
                )}
              </Card>
            </>
          )}
          <br />
          <Row gutter={16}>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                disabled={!monthToMonth && !renewalOptions ? true : false}
              >
                Prepare Renewal Letter
              </Button>
            </Col>
            <Col>
              <Button>Cancel</Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={preparRenewalsRightBar} />
      </div>
      <EditEelectronicSignature
        showModal={isModalOpen}
        cancelModal={onCancelModal}
      />
    </div>
  );
};

export default PrepareRenewalOffer;
